import { PixagriField } from 'library/src/fields/models/PixagriField';
import { AddRotation } from 'library/src/rotation/models/AddRotation';
import Rotation from '../models/Rotation';

export const ADD_NEW_ROTATION = 'ADD_NEW_ROTATION';
export interface AddNewRotationAction {
  type: typeof ADD_NEW_ROTATION;
  payload: {
    selectedFieldId: number;
    newRotation: AddRotation;
  };
}

export const MODIFY_ROTATION = 'MODIFY_ROTATION';
export interface ModifyRotationAction {
  type: typeof MODIFY_ROTATION;
  payload: {
    field_id: number;
    rotation: AddRotation;
  };
}

export const LOAD_ROTATIONS = 'LOAD_ROTATIONS';
export interface LoadRotationsAction {
  type: typeof LOAD_ROTATIONS;
  payload: {
    selectedFieldId: number | null;
  };
}

export const LOAD_ROTATIONS_SUCCESS = 'LOAD_ROTATIONS_SUCCESS';
export interface LoadRotationsSuccessAction {
  type: typeof LOAD_ROTATIONS_SUCCESS;
  payload: {[key: string]: Rotation};
}

export const DELETE_ROTATION = 'DELETE_ROTATION';
export interface DeleteRotationAction {
  type: typeof DELETE_ROTATION;
  payload: {
    selectedField: PixagriField | null;
    selectedRotationId: number | null;
  };
}

export const MODIFY_YIELD = 'MODIFY_YIELD';
export interface ModifyYieldAction {
  type: typeof MODIFY_YIELD;
  payload: {
    field_id: number;
    rotation: AddRotation;
  };
}

export const MODIFY_YIELD_SUCCESS = 'MODIFY_YIELD_SUCCESS';
export interface ModifyYieldSuccessAction {
  type: typeof MODIFY_YIELD_SUCCESS;
  payload: {
    field_id: number;
    rotation: AddRotation;
  };
}

export type RotationActionTypes =
  | AddNewRotationAction
  | ModifyRotationAction
  | LoadRotationsAction
  | LoadRotationsSuccessAction
  | DeleteRotationAction
  | ModifyYieldAction;

export const actions = {
  addNewRotation: (
    selectedFieldId: number,
    newRotation: AddRotation,
  ): AddNewRotationAction => {
    return {
      type: ADD_NEW_ROTATION,
      payload: {selectedFieldId, newRotation},
    };
  },

  modifyRotation: (
    fieldId: number,
    rotation: AddRotation,
  ): ModifyRotationAction => {
    return {
      type: MODIFY_ROTATION,
      payload: {
        field_id: fieldId,
        rotation: rotation,
      },
    };
  },

  loadRotation: (selectedFieldId: number | null): LoadRotationsAction => {
    return {
      type: LOAD_ROTATIONS,
      payload: {selectedFieldId},
    };
  },

  loadRotationsSuccess: (rotations: {
    [key: string]: Rotation;
  }): LoadRotationsSuccessAction => {
    return {
      type: LOAD_ROTATIONS_SUCCESS,
      payload: rotations,
    };
  },

  deleteRotation: (
    selectedField: PixagriField | null,
    selectedRotationId: number | null,
  ): DeleteRotationAction => {
    return {
      type: DELETE_ROTATION,
      payload: {selectedField, selectedRotationId},
    };
  },

  modifyYield: (field_id: number, rotation: AddRotation): ModifyYieldAction => {
    return {
      type: MODIFY_YIELD,
      payload: {field_id: field_id, rotation: rotation},
    };
  },

  modifyYieldSuccess: (
    field_id: number,
    rotation: AddRotation,
  ): ModifyYieldSuccessAction => {
    return {
      type: MODIFY_YIELD_SUCCESS,
      payload: {field_id: field_id, rotation: rotation},
    };
  },
};

export default actions;
